import configs from "constants/configs";
import { API_AUTH, API_AUTH_FILE } from "../common";

const KySoAPI = {
  // combo: ({}) => API_AUTH.get(`he-thong/mau-hop-dong`, {}),

  // comboMauPhieuThuChi: (type) =>
  //   API_AUTH.get(`quan-ly-thu-chi/combo-mau-thu-chi?type=${type}`, {}),

  downloadPDF: async (url, params = {}) => {
    try {
      const response = await API_AUTH_FILE.get(url, params, {
        responseType: "arraybuffer",
        transformResponse: [(data) => data], // 🔥 giữ nguyên binary
      });

      if (!response || !response.data) {
        throw new Error("No data");
      }

      // 🔥 convert sang Blob chuẩn
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      return {
        blob,
        headers: response.headers,
      };
    } catch (error) {
      console.error("Download PDF error:", error);
      throw error;
    }
  },

  getHash: async (mauhopdongId, chovayId) => {
    try {
      const res = await API_AUTH.get(
        `quanlychovay/ky-so-in?mauhopdongId=${mauhopdongId}&chovayId=${chovayId}&nameCongTy=NiemTin`,
        {},
      );

      if (!res || !res.data) {
        throw new Error("No hash data");
      }

      return res.data; // { hash: "..." }
    } catch (error) {
      console.error("Get hash error:", error);
      throw error;
    }
  },

  getKySoInPdf: (id) => KySoAPI.downloadPDF(`kyso/in?id=${id}`, {}),

  uploadSignedPDF: async (signature, choVayId, hash, certificate) => {
    const formData = new FormData();
    formData.append("chovayId", choVayId);
    formData.append("signature", signature);
    formData.append("hash", hash);
    formData.append("certificate", certificate);

    const response = await API_AUTH_FILE.post(
      "quanlychovay/embed-pdf",
      formData,
      {
        responseType: "arraybuffer",
        transformResponse: [(data) => data], // 🔥 giữ nguyên binary
      },
    );

    if (!response || !response.data) {
      throw new Error("Không nhận được file PDF từ server");
    }

    return new Blob([response.data], { type: "application/pdf" });
  },

  checkSignedPDF: async (pdfFile) => {
    const formData = new FormData();
    formData.append("file", pdfFile);

    const response = await API_AUTH.post("kyso/kiemtra", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (!response || !response.ok) {
      throw new Error(response?.data?.message || "Lỗi kiểm tra ký số");
    }

    return response.data;
  },

  getDanhSachKySo: (
    search,
    loaiHopDong,
    tuNgay,
    denNgay,
    trangThai,
    pageIndex,
    pageSize,
  ) =>
    API_AUTH.get(
      `kyso/danh-sach?search=${encodeURIComponent(search)}&loaiHopDong=${encodeURIComponent(loaiHopDong)}&tuNgay=${encodeURIComponent(tuNgay)}&denNgay=${encodeURIComponent(denNgay)}
      &trangThai=${encodeURIComponent(trangThai)}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {},
    ),

  cancelHopDongKySo: (ids, reason) =>
    API_AUTH.post("kyso/huy-hop-dong", {
      ids,
      reason,
    }),

  kiemTraHopDongChoVayKySo: (chovayId) =>
    API_AUTH.get(`kyso/kiem-tra-sua?chovayId=${chovayId}`, {}),
};

export default KySoAPI;
